{
  "mobile_header": {
    "open_sidebar": "Open sidebar",
    "logo_alt": "SparkLayer"
  },
  "sidebar": {
    "close": "Close sidebar",
    "test_mode": "Test mode",
    "nav": {
      "partner_dashboard": "Partner dashboard",
      "home": "Home",
      "activity": "Activity",
      "pricing": "Pricing",
      "price_lists": "Price lists",
      "price_editor": "Price editor",
      "discounts": "Discounts",
      "customers": "Customers",
      "companies": "Companies",
      "groups": "Groups",
      "sales_agents": "Sales agents",
      "agents": "Agents",
      "roles": "Roles",
      "forms": "Forms",
      "data_tables": "Data tables",
      "integrations": "Integrations",
      "platform": "Platform",
      "partners": "Partners",
      "product_sync": "Product sync",
      "storefront": "Storefront",
      "widgets": "Widgets",
      "options": "Options",
      "settings": "Settings",
      "onboarding": "Onboarding",
      "configurations": "Configurations",
      "shipping": "Shipping",
      "api": "API",
      "templates": "Templates"
    },
    "account_nav": {
      "account": "Account",
      "password": "Password",
      "plan": "Plan",
      "team": "Team",
      "sign_out": "Sign out"
    },
    "staff_nav": {
      "staff": "Staff",
      "manage_billing": "Manage billing",
      "manage_team": "Manage team",
      "customer_sync": "Customer sync"
    },
    "actions": {
      "help": "Help",
      "explore_features": "Explore features",
      "return_to_shopify": "Return to Shopify",
      "return_to_wix": "Return to Wix",
      "go_to_storefront": "Go to storefront"
    },
    "plan_link": {
      "confirm_plan": "Please confirm your plan",
      "select_plan": "Please select a plan",
      "trial_days_left": "{days, plural, =1 {1 day} other {# days}} left of trial"
    }
  },
  "user_menu": {
    "theme": {
      "label": "Theme",
      "light": "Light",
      "dark": "Dark",
      "system": "System"
    }
  },
  "site_switcher": {
    "search_label": "Quick search",
    "search_placeholder": "Search teams",
    "no_teams_found": "Sorry, no teams found.",
    "create_team": "Create team",
    "advanced_search_prompt": "Can't find what you're looking for?",
    "use_regular_search": "Return to regular search",
    "use_advanced_search": "Try our advanced search"
  },
  "storefront_leave_modal": {
    "title": "Discard unsaved changes?",
    "message": "Your storefront options have unsaved changes. Leaving this page will discard them.",
    "confirm": "Discard changes"
  },
  "theme_editor_leave_modal": {
    "title": "Discard unsaved changes?",
    "message": "Some template files have unsaved changes. Leaving the editor will discard them.",
    "confirm": "Discard changes"
  }
}
